import axios from "axios";

function getPersonalisationHistory(client_access_key, bearerToken) {
  return axios
    .get(`${process.env.REACT_APP_API_2_ENDPOINT}/personalisation-history`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + bearerToken,
        client_access_key: `${client_access_key}`,
      },
    })
    .then(response => response.data);
}

export default getPersonalisationHistory;
